import React from "react";
import "./Panel.scss";

const Panel = React.forwardRef(function Panel(
  {
    as: Component = "div",
    className = "",
    size = "default",
    row = true,
    hoverable = false,
    interactive = false,
    children,
    ...props
  },
  ref
) {
  const classes = ["app-panel"];

  if (size) {
    classes.push(`app-panel--${size}`);
  }

  if (row) {
    classes.push("app-row");
  }

  if (hoverable) {
    classes.push("app-row--hoverable");
  }

  if (interactive) {
    classes.push("app-row--interactive");
  }

  if (className) {
    classes.push(className);
  }

  return (
    <Component ref={ref} className={classes.join(" ")} {...props}>
      {children}
    </Component>
  );
});

export default Panel;
